function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Doc");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Doc",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  opacity: 0,
  x: 0,
  y: 0,
  width: 28,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M24,0 C24.5522847,-1.01453063e-16 25,0.44771525 25,1 L25,19 L17.5,19 L17.35554,19.0068666 C16.6424288,19.0750085 16.0750085,19.6424288 16.0068666,20.35554 L16,20.5 L16,28 L5,28 C4.44771525,28 4,27.5522847 4,27 L4,1 C4,0.44771525 4.44771525,1.01453063e-16 5,0 L24,0 Z M24.588,22 L19.3646007,27.6771722 C19.2624666,27.7881525 19.1377857,27.8733329 19.0007151,27.9282574 L19,22 L24.588,22 Z M15.5,12 L7.5,12 L7.5,15 L15.5,15 L15.5,12 Z M21.5,6 L7.5,6 L7.5,9 L21.5,9 L21.5,6 Z",
  id: "Combined-Shape",
  fill: "#3366CC"
})));

var SvgDoc = function SvgDoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doc.66264efd.svg";
export { ForwardRef as ReactComponent };